export default __webpack_public_path__ + "static/Xeris-privacy-policy-02b53d16d0e859143c02a96230f1c19b.pdf";